<template>
  <VBlock class="bill" :direction="Direction.column">
    <VBlock
      :margin="[0, 0, isReturnAndExchangeItemInCart ? 0 : 15, 0]"
      class="total-price-wrapper"
      :sort="Sort.space_between"
    >
      <VSpan text="주문금액" :size="18" :weight="TextWeight.bold" :color="TextColor.darkGray" />
      <VSpan
        :text="`${totalPrice}원`"
        :size="18"
        :weight="TextWeight.bold"
        :type="TextType.Number"
        :color="TextColor.darkGray"
      />
    </VBlock>
    <VBlock
      v-if="isProvideImmediateDiscount"
      v-show="!isReturnAndExchangeItemInCart"
      :margin="[0, 0, 15, 0]"
      class="immediate-discount-wrapper"
    >
      <VBlock class="immediate-discount">
        <VSpan text="즉시할인" :size="18" :color="TextColor.darkGray" />
        <VA :onClick="onImmediateButton">
          <VSpan class="detail" text="자세히" :size="14" :color="TextColor.brand" />
        </VA>
      </VBlock>
      <VSpan
        :text="`${immediateDiscount === 0 ? '' : '-'}${immediateDiscount}원`"
        :size="18"
        :type="TextType.Number"
        :weight="TextWeight.bold"
        :color="TextColor.darkGray"
      />
    </VBlock>
    <component
      v-show="!isReturnAndExchangeItemInCart"
      :is="deliveryTipComponent"
      v-bind="{ onDeliveryChargeButton, deliveryCharge, deliveryChargeBeforeDiscount }"
    />
    <VBlock
      v-show="isDisplayingMinimumText && !isReturnAndExchangeItemInCart"
      class="notice-wrapper"
      :sort="Sort.right_center"
    >
      <VSpan
        :text="`최소주문금액 ${minimumOrderPrice}원`"
        :size="16"
        :color="TextColor.emergency"
        :type="TextType.Number"
      />
    </VBlock>

    <VBlock :margin="[24, 0, 0, 0]" :direction="Direction.column">
      <VP :size="12" :text="deliveryTipEventText[0]" />
      <VP :size="12" :text="deliveryTipEventText[1]" />
    </VBlock>
  </VBlock>
</template>

<script>
import VSpan, {
  TextColor,
  TextType,
  TextWeight
} from '@/presentationals/v2/components/layouts/atoms/VSpan'

import VP from '@/presentationals/v2/components/layouts/atoms/VP'

import VA from '@/presentationals/v2/components/layouts/molecules/VA'
import VBlock, { Direction, Sort } from '@/presentationals/v2/components/layouts/molecules/VBlock'

import DeliveryTipLayout from './states/DeliveryTipLayout'
import DiscountDeliveryTipLayout from './states/DiscountDeliveryTipLayout'

import {
  isProvideImmediateDiscount,
  isProvideDeliveryTipDiscount
} from '../../../../../../config/featureProvider'

import { DeliveryTipEvent } from '../../../../../../config/eventProvider'

export default {
  name: 'CartBill',
  components: {
    VSpan,
    VBlock,
    VA,
    VP
  },
  props: {
    totalPrice: {
      type: Number,
      required: true
    },
    immediateDiscount: {
      type: Number,
      required: true
    },
    deliveryCharge: {
      type: Number,
      required: true
    },
    minimumOrderPrice: {
      type: Number,
      required: true
    },
    deliveryChargeBeforeDiscount: {
      type: Number,
      required: true
    },
    defaultDeliveryCharge: {
      type: Number,
      required: true
    },
    isReturnAndExchangeItemInCart: {
      type: Boolean,
      required: true
    },
    isEmptyImmediateDiscount: {
      type: Boolean,
      required: true
    },
    onImmediateButton: {
      type: Function,
      required: true
    },
    onDeliveryChargeButton: {
      type: Function,
      required: true
    }
  },
  computed: {
    isDisplayingMinimumText() {
      return this.totalPrice < this.minimumOrderPrice
    },
    isProvideImmediateDiscount() {
      const { appVersion, isAndroid } = this.$store.getters

      const hasImmediateDiscount = !this.isEmptyImmediateDiscount
      const provideImmediateDiscount = isProvideImmediateDiscount({ appVersion, isAndroid })

      return hasImmediateDiscount && provideImmediateDiscount
    },
    deliveryTipComponent() {
      return isProvideDeliveryTipDiscount ? DiscountDeliveryTipLayout : DeliveryTipLayout
    },

    deliveryTipEventText() {
      return DeliveryTipEvent.messages
    }
  },
  data() {
    return {
      TextColor,
      Direction,
      Sort,
      TextType,
      TextWeight
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.bill {
  width: 100%;
  height: auto;
  background-color: $background-white;
  box-sizing: border-box;
  padding: 25px 15px 25px 15px;
  border-bottom: 1px solid $light-gray-5;

  .immediate-discount-wrapper {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  .immediate-discount {
    width: auto;

    .detail {
      /* padding-top: 1px; */
      margin-left: 6px;
      border-radius: 25px;
      border: 1px solid $light-gray-4;
      background-color: $white;
      padding: 3px 8px 2px 8px;
    }
  }
}
</style>
